import React from 'react';

export const FontColorSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
  >
    <path
      d="M8.13334 28.2238C7.53126 28.2238 7.04207 28.0802 6.66577 27.7932C6.31455 27.5061 6.10131 27.1277 6.02605 26.658C5.95079 26.1621 6.03859 25.6141 6.28946 25.0139L16.2238 2.11385C16.55 1.35704 16.9388 0.822052 17.3904 0.508888C17.867 0.169629 18.4064 0 19.0085 0C19.5855 0 20.0997 0.169629 20.5513 0.508888C21.028 0.822052 21.4293 1.35704 21.7555 2.11385L31.7275 25.0139C32.0034 25.6141 32.1038 26.1621 32.0285 26.658C31.9533 27.1538 31.74 27.5453 31.3888 27.8323C31.0376 28.0933 30.5735 28.2238 29.9965 28.2238C29.2941 28.2238 28.7422 28.0542 28.3408 27.7149C27.9645 27.3495 27.6258 26.8015 27.3247 26.0708L24.8788 20.1598L26.9108 21.5299H11.0309L13.0629 20.1598L10.6546 26.0708C10.3284 26.8276 9.98977 27.3756 9.63855 27.7149C9.28734 28.0542 8.7856 28.2238 8.13334 28.2238ZM18.9332 5.75436L13.665 18.7898L12.6866 17.5371H25.2551L24.3143 18.7898L19.0085 5.75436H18.9332Z"
      fill="black"
    />
    <rect
      x="1"
      y="37"
      width="6"
      height="36"
      rx="3"
      transform="rotate(-90 1 37)"
      fill="url(#paint0_linear_17694_45915)"
      stroke="url(#paint1_linear_17694_45915)"
      strokeWidth="2"
    />
    <defs>
      <linearGradient
        id="paint0_linear_17694_45915"
        x1="4"
        y1="38"
        x2="4"
        y2="76"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF0000" />
        <stop offset="0.234375" stopColor="#FFD600" stopOpacity="0.88" />
        <stop offset="0.479167" stopColor="#05FF00" />
        <stop offset="0.729167" stopColor="#3BB9FF" />
        <stop offset="1" stopColor="#001AFF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_17694_45915"
        x1="4"
        y1="38"
        x2="4"
        y2="76"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E70000" />
        <stop offset="0.234375" stopColor="#E3BE00" stopOpacity="0.88" />
        <stop offset="0.5" stopColor="#05E600" />
        <stop offset="0.760417" stopColor="#37A1DC" />
        <stop offset="1" stopColor="#001DDF" />
      </linearGradient>
    </defs>
  </svg>
);

export default FontColorSvg;
